module.exports = __webpack_public_path__ + "img/1026.6f929e86.png";